import ActionButton from '../ActionButton/ActionButton';
import { Flex } from '../ui/flex';

import { FirstActionModalProps } from './FirstActionModal.types';

import './style.scss';

const FirstActionModal = ({
  actionButtonIcon,
  headline,
  text,
  actionButtonFunc,
  actionButtonText,
  actionButtonDisabled,
  actionButtonTooltip,
  height
}: FirstActionModalProps) => {
  return (
    <Flex
      justify="center"
      align="center"
      className="w-full firstActionModalContainer"
      style={{ height: height ?? 'calc(100vh - 112px)' }}
    >
      <div className="firstActionModal">
        <h3>{headline}</h3>
        <p>{text}</p>
        {actionButtonText && (
          <ActionButton
            style={{
              marginTop: '1rem'
            }}
            onClick={actionButtonFunc}
            icon={actionButtonIcon}
            text={actionButtonText}
            disabled={actionButtonDisabled}
            tooltip={actionButtonTooltip}
            fullWidth
          />
        )}
      </div>
    </Flex>
  );
};

export default FirstActionModal;
